import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';

export const fetchTrainers = createAsyncThunk(
  'trainers/fetchTrainers',
  async (
    { page = 1, limit = 8, searchValue = '', sortBy = '', sortOrder = '' } = {}, // Изменено: добавили searchValue, sortBy, sortOrder и установили limit=8
    { rejectWithValue, getState }
  ) => {
    try {
      const state = getState();
      const clubId = state.club?.club?.id;

      if (!clubId) return rejectWithValue('Club ID not found');

      // Формируем URL с учетом всех параметров
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', limit);
      if (searchValue) {
        params.append('searchValue', searchValue);
      }
      if (sortBy) {
        params.append('sortBy', sortBy);
      }
      if (sortOrder) {
        params.append('sortOrder', sortOrder);
      }

      const response = await api.get(
        `/trainer/${clubId}?${params.toString()}` // Изменено: эндпоинт 'trainer' вместо 'trainers'
      );
      const { data, pagination } = response.data;

      return { data, pagination };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Ошибка запроса');
    }
  }
);

const initialState = {
  trainers: {
    data: [],
    pagination: {
      page: 1, // Добавлено для инициализации
      limit: 8, // Добавлено для инициализации
      total: 0, // Добавлено для инициализации
      totalPages: 1, // Добавлено для инициализации
    },
  },
  isLoadingTrainers: false,
  errorTrainers: null,
};

const trainersSlice = createSlice({
  name: 'trainers',
  initialState,
  reducers: {
    addTrainer(state, action) {
      // Добавляем нового тренера в начало списка и обновляем total
      state.trainers.data.unshift(action.payload);
      if (state.trainers.pagination?.total != null) {
        state.trainers.pagination.total += 1;
      }
    },
    // Ваш код editTrainer и deleteTrainer остаются без изменений
    editTrainer(state, action) {
      const { id } = action.payload;
      const index = state.trainers.data.findIndex((tr) => tr.id === id);
      if (index !== -1) {
        state.trainers.data[index] = {
          ...state.trainers.data[index],
          ...action.payload,
        };
      }
    },
    deleteTrainer(state, action) {
      state.trainers.data = state.trainers.data.filter(
        (tr) => tr.id !== action.payload
      );
      if (state.trainers.pagination?.total != null) {
        state.trainers.pagination.total -= 1;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrainers.pending, (state) => {
        state.isLoadingTrainers = true;
      })
      .addCase(fetchTrainers.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;

        const updatedData = data.map((trainer) => {
          const { user } = trainer;

          return {
            ...trainer,
            user: {
              ...user,
              fullName: [user?.lastName, user?.firstName]
                .filter(Boolean)
                .join(' '),
            },
          };
        });

        state.trainers.data = updatedData;
        state.trainers.pagination = pagination;
        state.isLoadingTrainers = false;
      })

      .addCase(fetchTrainers.rejected, (state, action) => {
        state.isLoadingTrainers = false;
        state.errorTrainers = action.payload || 'Что-то пошло не так';
      });
  },
});

export const { addTrainer, editTrainer, deleteTrainer } = trainersSlice.actions;

export default trainersSlice.reducer;
